const setRatio = (container, ratio) => {
  if (!container.hasAttribute('aspect-ratio')) return;

  container.setAttribute('aspect-ratio', ratio);
};

export default setRatio;
